const root = document.querySelector('[data-wedding-service]');
const form = root?.querySelector('[data-wedding-form]');
const status = root?.querySelector('[data-wedding-status]');
const strings = JSON.parse(root?.querySelector('[data-wedding-strings]')?.textContent ?? '{}');

form?.addEventListener('submit', async (event) => {
  event.preventDefault();
  const source = form.querySelector('[data-wedding-source-url]');
  if (source) source.value = window.location.href;
  const submit = form.querySelector('[type="submit"]');
  const data = new FormData(form);
  const payload = Object.fromEntries(data.entries());
  payload.privacyAcknowledged = data.get('privacyAcknowledged') === 'on';
  payload.marketingConsent = data.get('marketingConsent') === 'on';
  submit.disabled = true; status.textContent = strings.sending; status.dataset.state = '';
  try {
    const response = await fetch(form.action, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    if (!response.ok) throw new Error('request_failed');
    form.reset(); status.textContent = strings.success; status.dataset.state = 'success';
  } catch {
    status.textContent = strings.error; status.dataset.state = 'error';
  } finally { submit.disabled = false; }
});
